import React, { useState, useEffect } from 'react';
import ProgressBar from './ProgressBar';

const index = ({ completed }) => {
  const [res, setRes] = useState(0);

  useEffect(() => {
    if (res >= 100) clearInterval(x);
    let x = setInterval(() => runProgress(), 1000);
    return () => clearInterval(x);
  }, [res]);

  useEffect(() => {
    if (completed) {
      setRes(100);
    }
  }, [completed]);
  const runProgress = () => {
    if (res < 90) setRes((res) => res + 10);
  };

  return (
    <div className="relative w-full h-88 ">
      <div
        className="text-center w-11/12 md:w-9/12 mx-auto px-5 "
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <p className="text-black-1011 font-roboto font-normal text-base mb-2">
          {res}%
        </p>
        <ProgressBar bgcolor={'#00ACB8'} completed={res} />
      </div>
    </div>
  );
};
export default index;
